import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core'

import { ResourceUsagesViewReferencesComponent } from '@flowx/designer/shared/components/resource-usages/resource-usages-view-references.component'

import { ResourceUsage, ResourceUsageView } from '../../model/resource-usage.model'

@Component({
  selector: 'flx-resource-usages-delete-confirmation',
  templateUrl: './resource-usages-delete-confirmation.component.html',
  imports: [ResourceUsagesViewReferencesComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[class.flx-empty]': 'totalResourceUsages() === 0',
  },
})
export class ResourceUsagesDeleteConfirmationComponent {
  readonly ResourceUsageView = ResourceUsageView

  resourceUsages = input.required<ResourceUsage[]>()
  viewUsagesClicked = output<ResourceUsage[]>()

  totalResourceUsages = computed(() => this.resourceUsages().length)
}
